import { useQuery } from "react-query";
import { getStudentDuplicatedSchoolCodes } from "../services/school/student/getStudents";
import { PagedRequestType } from "../types/PagedResults";
import { Key_studentsWithDuplicatedCodes } from "../utils/constants";

export const useGetStudentsWithDuplicatedSchoolCodesQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_studentsWithDuplicatedCodes, JSON.stringify(data)],
    () => getStudentDuplicatedSchoolCodes(data), 
    options?{...options}:{}
  );